<template>
    <div>
        <vx-card titleIcon="FilterIcon" title="Advanced Filters">
            <div class="vx-row mt-2">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">General</label>
                    <vs-input class="w-full" v-model="filters['search']"></vs-input>
                </div>
                <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">View By RM Stock Status</label>
                    <v-select :clearable="true" placeholder="" v-model="filters['status']"
                        :options="['In_Stock', 'Out_of_Stock', 'Expired']" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </div> -->
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">Shelf Life</label>
                    <v-select :clearable="true" placeholder="" @input="onSelectCustomFilter" label="key"
                        :options="custom_filter_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :reduce="option => option.value"></v-select>
                </div>
            </div>
            <div class="vx-row mb-4 hidden">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-from']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-from']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-from']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-from']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
            </div>
        </vx-card>
        <vx-card class="mt-4">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vx-card no-shadow class="pt-2">
                        <div slot="no-body">
                            <vs-table id="raw-material-stock-popup" :max-items="(meta.per_page) ? meta.per_page : 10"
                                :data="items" :sst="true" stripe @sort="handleSort"
                                class="table-dark-inverted table-auto vs-con-loading__container">

                                <template slot="thead">
                                    <vs-th width="15%" class="text-sm">BATCH NO</vs-th>
                                    <vs-th width="10%" class="text-sm">ITS PRODUCT CODE</vs-th>
                                    <vs-th width="10%" class="text-sm">ITS PRODUCT
                                        NAME</vs-th>
                                    <vs-th width="5%" class="text-sm">SUPPLIER BATCH NUMBER</vs-th>
                                    <vs-th width="10%" class="text-sm">SHELF LOCATION</vs-th>
                                    <vs-th width="10%" class="text-sm">MANUFACTURE DATE</vs-th>
                                    <vs-th sort-key="expiration-date" width="10%" class="text-sm">EXPIRATION DATE</vs-th>
                                    <vs-th width="5%" class="text-sm">QUANTITY (KG)</vs-th>
                                    <vs-th sort-key="expiration-date" width="5%" class="text-sm">SHELF LIFE (DAYS)</vs-th>
                                     <vs-th width="10%" class="text-sm">STOCK STATUS</vs-th>
                                    <!-- <vs-th width="8%" class="text-sm">OPENED</vs-th> -->
                                    <vs-th width="10%" class="text-sm">ACTION</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr @click.native="onClickUpdateRmStock(data[indextr])" class="text-sm"
                                        style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                                        <vs-td :data="data[indextr].batch_no">
                                            {{ data[indextr].batch_no }}
                                        </vs-td>

                                        <vs-td class="text-primary font-semibold"
                                            :data="data[indextr].company_product_code">
                                            {{ data[indextr].category }}-{{ data[indextr].company_product_code }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].company_product_name">
                                            {{ data[indextr].company_product_name }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].supplier_batch_no">
                                            {{ data[indextr].supplier_batch_no }}
                                        </vs-td>

                                        <vs-td>
                                            R {{ data[indextr].shelf_location_r || '-' }} | S {{
                                                data[indextr].shelf_location_s
                                                || '-' }} | L {{ data[indextr].shelf_location_l || '-' }}
                                        </vs-td>


                                        <vs-td :data="data[indextr].manufacture_date">
                                            {{ data[indextr].manufacture_date }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].expiration_date">
                                            {{ data[indextr].expiration_date }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].available_quantity">
                                            {{ Number(data[indextr].available_quantity).toFixed(4) | remove_trailing_zeros
                                            }}
                                        </vs-td>

                                        <vs-td>
                                            {{ shelfLifeGenerator(data[indextr].expiration_date) }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].status">
                                            <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                                                {{ data[indextr].status | stock_status_format }}
                                            </vs-chip>
                                        </vs-td>

                                        <!-- <vs-td :data="data[indextr].is_opened">
                                            <div class="flex items-center" @click.stop>
                                                <vx-tooltip :text="getOpenedTooltipText(data[indextr])" position="bottom">
                                                    <vs-switch
                                                        :disabled="isBatchOpenedToggleDisabled(data[indextr])"
                                                        :value="!!data[indextr].is_opened"
                                                        @input="onToggleOpened(data[indextr])"
                                                        icon-pack="feather"
                                                        vs-icon-on="icon-check-circle"
                                                        vs-icon-off="icon-slash"
                                                    />
                                                </vx-tooltip>
                                            </div>
                                        </vs-td> -->

                                        <vs-td>
                                            <div class="vx-row">
                                                <vx-tooltip class="mr-2" text="Update rm stock" position="bottom">
                                                    <vs-button class="ml-3"
                                                        @click.stop="onClickUpdateRmStock(data[indextr])" size="small"
                                                        color="warning" type="border" icon-pack="feather"
                                                        icon="icon-edit"></vs-button>
                                                </vx-tooltip>
                                                <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'"
                                                    class="flex justify-start mr-2" text="View QC Test" position="bottom">
                                                    <vs-button class="flex justify-end"
                                                        @click.stop="onClickUpdateQcTest(data[indextr].q_c_test.id, data[indextr].rm_id)"
                                                        size="small" color="primary" type="border" icon-pack="feather"
                                                        icon="icon-eye"></vs-button>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>

                                    </vs-tr>
                                </template>


                            </vs-table>

                            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                                :max-items="perPage" description-body="Rows per page" description-connector="of"
                                description-title="Records" description :description-items="descriptionItems"
                                :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                            </vs-pagination>


                        </div>
                    </vx-card>
                </div>
            </div>
        </vx-card>
        <update-rm-stock-pop-up v-on:refreshData="refreshData" ref="UpdateRmStockPopUp" />
        <update-qc-test-rm-order-item-pop-up ref="updateQcTestRmOrderItemPopUp" />
    </div>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
const ManufacturingRepository = RepositoryFactory.get('manufacturing')

import UpdateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/UpdateRmStockPopUp";
import UpdateQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/UpdateQcTestRmOrderItemPopUp";

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import moment from "moment";

export default {
    name: 'ViewRawMaterialStockPopUp',
    mixins: [SuccessMessage, ErrorMessages, Filter],
    data() {
        return {
            open: false,
            id: '',
            items: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            its_prod_code: '',
            createForm: {},
            custom_filter_options: [
                { key: '30-90 days short shelf life', value: 1 },
                { key: 'Less than 30 days to expiry', value: 2 },
                { key: 'Expired', value: 3 },
            ],
            filterQuery: ''
        }
    },
    async mounted() {
        await this.fetchRmStockInventory()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState())
                this.id = id
                this.open = true;
                await this.fetchRmStockInventory()
            } catch (error) {

            }
        },
        closePopup() {
            this.open = false
        },
        async refreshData() {
            await this.fetchRmStockInventory()
        },
        async fetchRmStockInventory() {
            await this.$vs.loading({
                container: '#raw-material-stock-popup',
                scale: 0.45
            })
            try {
                const today = moment().format('DD/MM/YYYY');
                const expiryTo = moment(today, 'DD/MM/YYYY').add(90, 'days').format('DD/MM/YYYY');
                if(this.filterQuery.length === 0) {
                    this.filterQuery = `filter[expiry-to]=${expiryTo}&filter[status]=In_Stock,Expired`
                }
                const { data } = await ManufacturingRepository.getRawMaterialStock(this.page, `${this.filterQuery}`, this.perPage, this.sort)
                this.items = data.data
                this.meta = data.meta
            } catch (e) {
                this.showWarningMessage('Something went wrong. Please try again!')
            }
            this.$vs.loading.close('#raw-material-stock-popup > .con-vs-loading')
        },
        onClickUpdateRmStock(data) {
            this.$refs.UpdateRmStockPopUp.openPopup(data.id)
        },
        isBatchOpenedToggleDisabled(item) {
            if (!item) return true
            const isStatusOk = item.status === 'In_Stock' || item.status === 'In-Stock'
            const isQtyOk = Number(item.available_quantity) > 0
            return !isStatusOk || !isQtyOk
        },
        getOpenedTooltipText(item) {
            if (this.isBatchOpenedToggleDisabled(item)) {
                return 'Opened status can only be changed for in-stock batches with available quantity.'
            }
            return item.is_opened ? 'Batch is Opened / Started (Click to toggle)' : 'Batch is Unopened (Click to toggle)'
        },
        async onToggleOpened(item) {
            if (this.isBatchOpenedToggleDisabled(item)) {
                this.showWarningMessage('Opened status can only be changed for in-stock batches with available quantity.')
                return
            }
            try {
                const newStatus = !item.is_opened
                await ManufacturingRepository.toggleRawMaterialStockOpened(item.id, { is_opened: newStatus })
                this.$set(item, 'is_opened', newStatus)
                this.showSuccessMessage(`Batch ${item.batch_no || ''} ${newStatus ? 'marked as Opened/Started' : 'marked as Unopened'}`)
            } catch (e) {
                this.convertAndNotifyError(e)
            }
        },
        async onClickUpdateQcTest(test_id, rm_id) {
            await this.$refs.updateQcTestRmOrderItemPopUp.openPopup(test_id, rm_id)
        },
        filterQueryUpdate() {
            this.fetchRmStockInventory()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchRmStockInventory()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchRmStockInventory()
            }

        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        toFixed(number) {
            return Math.floor(number * 10000) / 10000
            // return Number(number).toFixed(4)
        },
        onSelectCustomFilter(value) {
            const today = moment().format('DD/MM/YYYY');
            let expiryFrom = '';
            let expiryTo = '';
            let status = 'In_Stock';

            if (value === 1) {
                expiryFrom = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
                expiryTo = moment(today, 'DD/MM/YYYY').add(90, 'days').format('DD/MM/YYYY');
            } else if (value === 2) {
                expiryFrom = today;
                expiryTo = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
            } else if (value === 3) {
                // expiryTo = today;
                status = 'Expired'
            } else {
                status = ''
            }
            this.filterQuery = ''
            if(value) {
                this.filterQuery += `&filter[expiry-from]=${expiryFrom}&filter[expiry-to]=${expiryTo}&filter[status]=${status}`;
            } else {
                this.filterQuery = ''
            }
            this.page = 1
            this.fetchRmStockInventory();
        },
        shelfLifeGenerator(date) {
            const today = moment()
            const exp_date = moment(date, 'DD/MM/YYYY');
            return exp_date.diff(today, 'days') > 0 ? exp_date.diff(today, 'days') : ''
        }
    },

    components: {
        'v-select': vSelect,
        UpdateRmStockPopUp,
        UpdateQcTestRmOrderItemPopUp,
        flatPickr,
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
    watch: {
        page() {
            this.fetchRmStockInventory()
        },
        perPage() {
            this.fetchRmStockInventory()
        },
    }
}
</script>
  
<style scoped>
.raw-material-stock-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
}
</style>
  